import MDataListHoliday from './index.vue';

MDataListHoliday.install = app => {
  app.component(MDataListHoliday.name, MDataListHoliday);
};

export default MDataListHoliday;
